import WasmController from "react-lib/frameworks/WasmController";
// sequence
import * as AffiliateCommission from "./sequence/AffiliateCommission";
import * as BillingAndPackage from "./sequence/BillingAndPackage";
import * as MakeAppointmentMeHey from "./sequence/MakeAppointmentMeHey";
import * as Holiday from "./sequence/HolidaySetting";
import * as AppointmentListMEH from "./sequence/AppointmentListMEH";
import * as SaveServiceOrder from "./sequence/SaveServiceOrder";
import * as ScheduleSetting from "./sequence/ScheduleSetting";
import * as PaymentSummary from "./sequence/PaymentSummary";
import * as PaymentHistory from "./sequence/PaymentHistory";

import * as MeBilling from "./types/MeBillingType";
import * as MeChart from "./sequence/MeChart";
import * as MeScript from "./sequence/MeScript";
import * as MeReport from "./sequence/MeReport";

import Cookies from "js-cookie";

// APIs
import LabOrderPhlebotomyQueueList from "issara-sdk/apis/LabOrderPhlebotomyQueueList_apps_LAB";
import EncounterCallQueue from "issara-sdk/apis/EncounterCallQueue_core";
import ProxyPatientHasDivisionAdminList from "issara-sdk/apis/ProxyPatientHasDivisionAdminList_apps_PRX";
import TherapistRegistrationListView from "issara-sdk/apis/TherapistRegistrationListView_apps_MEH";
import EducationList from "issara-sdk/apis/EducationList_core";
import SpecialtyList from "issara-sdk/apis/SpecialtyList_core";
import ClinicalTermSetView from "issara-sdk/apis/ClinicalTermSetView_core";
import TherapistRegisterDocumentListView from "issara-sdk/apis/TherapistRegisterDocumentListView_apps_MEHM";
import EmployeeDocumentListCreateAPI from "issara-sdk/apis/EmployeeDocumentListCreateAPI_usersM";
import TherapistRegistrationDetailView from "issara-sdk/apis/TherapistRegistrationDetailView_apps_MEH";
import DoctorTherapyDetailView from "issara-sdk/apis/DoctorTherapyDetailView_apps_MEH";
import DoctorList from "issara-sdk/apis/DoctorList_core";
import DoctorTherapyItemDetailView from "issara-sdk/apis/DoctorTherapyItemDetailView_apps_MEH";
import DoctorTherapyListView from "issara-sdk/apis/DoctorTherapyListView_apps_MEH";
import Scheduling from "issara-sdk/apis/Scheduling_apps_QUE";
import AuditLogListView from "issara-sdk/apis/AuditLogListView_core";
import AppointmentPaymentRelationListView from "issara-sdk/apis/AppointmentPaymentRelationListView_apps_MEH";
import PaymentRelationListView from "issara-sdk/apis/PaymentRelationListView_apps_BIL";
import UserDetailAPIView from "issara-sdk/apis/UserDetailAPIView_users";
import AppointmentPaymentRelationActionView from "issara-sdk/apis/AppointmentPaymentRelationActionView_apps_MEHM";
import PaymentActionView from "issara-sdk/apis/PaymentActionView_apps_BIL";
import MeHealthPackageListView from "issara-sdk/apis/MeHealthPackageListView_apps_MEH";
import MeHealthPackageDetailView from "issara-sdk/apis/MeHealthPackageDetailView_apps_MEH";
import TermsAndConditionsList from "issara-sdk/apis/TermsAndConditionsList_apps_MEH";
import TermsAndConditionsLatestDetail from "issara-sdk/apis/TermsAndConditionsLatestDetail_apps_MEH";
import TermsAndConditionsDetail from "issara-sdk/apis/TermsAndConditionsDetail_apps_MEH";
import TermsAndConditionsActionLogList from "issara-sdk/apis/TermsAndConditionsActionLogList_apps_MEH";
import MeHealthServicePricingListView from "issara-sdk/apis/MeHealthServicePricingListView_apps_MEH";
import MeHealthCreditWalletLatestDetailView from "issara-sdk/apis/MeHealthCreditWalletLatestDetailView_apps_MEH";

// Utils
import moment from "moment-timezone";

export type Props = {};

export type State = {
  errorMessage?: any;
  successMessage?: any;
  buttonLoadCheck?: any;
  userSelectedLanguage?: "en" | "th";
  currentTherapists?: any[];
  educationList?: any[];
  specialtyList?: any[];
  clinicalTermSet?: any;
  therapistDocuments?: any;
  employeeDocuments?: any;
  doctorTherapyDetail?: any;
  doctorList?: any[];
  doctorTherapyItemDetail?: any;
  doctorTherapyList?: any[];
  schedulingList?: any[];
  auditLogList?: any[];
  appointmentPaymentRelationList?: any[];
  userDetail?: any;
  meHealthPackageList?: any[];
  termsAndConditionsList?: any[];
  latestTermAndConditions?: any;
  termsAndConditionsActionLogList?: any[];
  phlebotomyQueue?: {
    appointments: any[];
    walk_ins: any[];
  };
  meBillingActiveTab?: number;
  meBillingInitialMenu?: string;
} & BillingAndPackage.State &
  MakeAppointmentMeHey.State &
  Holiday.State &
  ScheduleSetting.State &
  AppointmentListMEH.State &
  SaveServiceOrder.State &
  PaymentSummary.State &
  PaymentHistory.State &
  MeBilling.State &
  MeChart.State &
  MeScript.State &
  MeReport.State &
  AffiliateCommission.State;

export const StateInitial: State = {
  ...BillingAndPackage.StateInitial,
  ...MakeAppointmentMeHey.StateInitial,
  ...Holiday.StateInitial,
  ...ScheduleSetting.StateInitial,
  ...AppointmentListMEH.StateInitial,
  ...SaveServiceOrder.StateInitial,
  ...PaymentSummary.StateInitial,
  ...PaymentHistory.StateInitial,
  ...MeBilling.StateInitial,
  ...MeChart.StateInitial,
  ...MeScript.StateInitial,
  ...MeReport.StateInitial,
  ...AffiliateCommission.StateInitial,
};

export type Event =
  | { message: "GetPhlebotomyQueue"; params: any }
  | {
      message: "CallPhlebotomyQueue";
      params: {
        encounterId: number;
        labOrderId?: number;
        patientId?: number;
        queueType: number;
        vn?: string;
      };
    }
  | { message: "HandleGetTherapistList"; params: any }
  | { message: "HandleGetEducationList"; params: any }
  | { message: "HandleGetSpecialtyList"; params: any }
  | { message: "HandleGetClinicalTermSet"; params: any }
  | { message: "HandleGetTherapistDocuments"; params: any }
  | { message: "HandleGetEmployeeDocuments"; params: any }
  | { message: "HandleSearchTherapistList"; params: any }
  | { message: "HandleApproveTherapist"; params: any }
  | { message: "HandleRejectTherapist"; params: any }
  | { message: "HandleCancelTherapist"; params: any }
  | { message: "HandleGetDoctorTherapyDetail"; params: any }
  | { message: "HandleGetDoctorList"; params: any }
  | { message: "HandleGetDoctorTherapyItemDetail"; params: any }
  | { message: "HandleGetDoctorTherapyList"; params: any }
  | { message: "HandleGetScheduling"; params: any }
  | { message: "HandleGetAuditLogList"; params: any }
  | { message: "HandleGetAppointmentPaymentRelationList"; params: any }
  | { message: "HandleGetUserDetail"; params: any }
  | { message: "HandlePostAppointmentPaymentRelationAction"; params: any }
  | { message: "HandleFilterAppointmentPaymentRelationList"; params: any }
  | { message: "HandleGetMeHealthPackageList"; params: any }
  | { message: "HandleCreateMeHealthPackage"; params: any }
  | { message: "HandleUpdateMeHealthPackage"; params: any }
  | { message: "HandleGetTermsAndConditionsList"; params: any }
  | { message: "HandleCreateTermsAndConditions"; params: any }
  | { message: "HandleGetLatestTermsAndConditions"; params: any }
  | { message: "HandleUpdateTermsAndConditions"; params: any }
  | { message: "HandleGetTermsAndConditionsActionLogList"; params: any }
  | { message: "HandleGetBonusCreditForNewOA"; params: any }
  | { message: "HandleGetCreditWalletLatest"; params: any }
  | BillingAndPackage.Event
  | MakeAppointmentMeHey.Event
  | Holiday.Event
  | ScheduleSetting.Event
  | AppointmentListMEH.Event
  | SaveServiceOrder.Event
  | PaymentSummary.Event
  | PaymentHistory.Event
  | MeBilling.Event
  | MeChart.Event
  | MeScript.Event
  | MeReport.Event;

export type Data = {
  division?: number;
};

export const DataInitial = {};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

/* ------------------------------------------------------ */

/*                           API                          */

/* ------------------------------------------------------ */

export const HandleGetTherapistList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getAllTherapists";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [firstRes, firstErr] = await TherapistRegistrationListView.list({
    params: { limit: 1 },
    apiToken,
  });

  if (firstErr || !firstRes) {
    controller.setState({
      currentTherapists: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถดึงข้อมูลนักบำบัด" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  const total = firstRes.total;
  const limit = 100;
  const offset = Math.max(0, total - limit);

  const [res, err] = await TherapistRegistrationListView.list({
    params: { limit, offset },
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      currentTherapists: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถดึงข้อมูลนักบำบัด" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    currentTherapists: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: { ...state.successMessage, [actionKey]: "Therapist list fetched successfully" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetEducationList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getEducationList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await EducationList.list({
    apiToken,
    params: params || {},
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      educationList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Failed to fetch education list" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    educationList: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: { ...state.successMessage, [actionKey]: "Education list fetched successfully" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetSpecialtyList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getSpecialtyList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await SpecialtyList.list({
    apiToken,
    params: params || {},
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      specialtyList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Failed to fetch specialty list" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    specialtyList: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: { ...state.successMessage, [actionKey]: "Specialty list fetched successfully" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetClinicalTermSet: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getClinicalTermSet";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await ClinicalTermSetView.post({
    apiToken: apiToken || Cookies.get("apiToken"),
    data: {
      question: ["edu_institution", "edu_category"],
      ...params,
    },
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      clinicalTermSet: {},
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Failed to fetch clinical term set" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    clinicalTermSet: res || {},
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Clinical term set fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetEmployeeDocuments: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const employeeId = params?.employee_id;
  const actionKey = "getEmployeeDocuments";

  if (!employeeId) {
    console.warn("Employee ID not provided for fetching documents.");
    controller.setState({
      employeeDocuments: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Employee ID is required" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await EmployeeDocumentListCreateAPI.list({
    employee_id: employeeId,
    params: params?.queryParams,
    apiToken,
    extra: params?.extraApiParams,
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      employeeDocuments: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Failed to fetch employee documents" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    employeeDocuments: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Employee documents fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetTherapistDocuments: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const therapistId = params?.therapistId || params?.therapist_id;
  const actionKey = "getTherapistDocuments";

  if (!therapistId) {
    console.warn("Therapist ID not provided for fetching documents.");
    controller.setState({
      therapistDocuments: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Therapist ID is required" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await TherapistRegisterDocumentListView.list({
    params: { therapist_id: therapistId },
    apiToken,
    extra: params?.extraApiParams,
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      therapistDocuments: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "Failed to fetch therapist documents" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  console.log("document:", res);

  controller.setState({
    therapistDocuments: Array.isArray(res) ? res : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Therapist documents fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleSearchTherapistList: Handler = async (controller, params) => {
  const { name, status, startDate, endDate, rejectStartDate, rejectEndDate } = params;
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "searchTherapists";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const apiParams: any = { limit: 100, offset: 0, text: name || "" };

  if (status) {
    apiParams.status__in = status;
  }

  if (startDate) apiParams.last_submit_at__gte = startDate;
  if (endDate) apiParams.last_submit_at__lte = endDate;

  const [res, err] = await TherapistRegistrationListView.list({
    params: apiParams,
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      currentTherapists: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถค้นหานักบำบัดได้" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  let items = Array.isArray(res.items) ? res.items : [];
  if (name) {
    const lowerName = name.toLowerCase();
    items = items.filter((t: any) => {
      const fullName =
        t.employee?.full_name?.trim() ||
        `${t.employee?.first_name ?? ""} ${t.employee?.last_name ?? ""}`.trim();

      return fullName.toLowerCase().includes(lowerName);
    });
  }

  if (rejectStartDate) {
    const start = new Date(rejectStartDate).getTime();
    items = items.filter(
      (t: any) => t.last_reject_at && new Date(t.last_reject_at).getTime() >= start,
    );
  }
  if (rejectEndDate) {
    const end = new Date(rejectEndDate).getTime();
    items = items.filter(
      (t: any) => t.last_reject_at && new Date(t.last_reject_at).getTime() <= end,
    );
  }

  controller.setState({
    currentTherapists: Array.isArray(items) ? items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: { ...state.successMessage, [actionKey]: "ค้นหาสำเร็จ" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

// ---------- action TherapistRegistration
export const HandleApproveTherapist: Handler = async (controller, params) => {
  const { therapistId, comment } = params;
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "approveTherapist";

  if (!therapistId) {
    console.error("therapistId is required");
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await TherapistRegistrationDetailView.patch({
    pk: therapistId,
    data: { action: "APPROVE", comment },
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถอนุมัตินักบำบัดได้" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  params.onSuccess?.();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: "อนุมัตินักบำบัดเรียบร้อยแล้ว" },
  });

  await HandleSearchTherapistList(controller, {});
};

export const HandleRejectTherapist: Handler = async (controller, params) => {
  const { therapistId, comment } = params;
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "rejectTherapist";

  if (!therapistId) {
    console.error("therapistId is required");
    return;
  }

  if (!comment || comment.trim() === "") {
    console.error("Reject reason is required");
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, _net] = await TherapistRegistrationDetailView.patch({
    pk: therapistId,
    data: { action: "REJECT", comment },
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถปฏิเสธนักบำบัดได้" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  params.onSuccess?.();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: "ปฏิเสธนักบำบัดเรียบร้อยแล้ว" },
  });

  await HandleSearchTherapistList(controller, {});
};

export const HandleCancelTherapist: Handler = async (controller, params) => {
  const { therapistId, comment } = params;
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "cancelTherapist";

  if (!therapistId) {
    console.error("therapistId is required");
    return;
  }

  if (!comment || comment.trim() === "") {
    console.error("Cancel reason is required");
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, _net] = await TherapistRegistrationDetailView.patch({
    pk: therapistId,
    data: { action: "CANCEL", comment },
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: { ...state.errorMessage, [actionKey]: "ไม่สามารถลบนักบำบัดได้" },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  params.onSuccess?.();

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: "ลบนักบำบัดเรียบร้อยแล้ว" },
  });

  await HandleSearchTherapistList(controller, { status: "S" });
};

// ----------
export const HandleGetDoctorTherapyDetail: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getDoctorTherapyDetail";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const doctor_id = params?.doctor_id;
  if (!doctor_id) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Doctor ID is required to fetch therapy detail",
      },
    });
    return;
  }

  const [res, err, net] = await DoctorTherapyDetailView.retrieve({
    doctor_id,
    apiToken,
    params: params || {},
  });

  console.log("HandleGetDoctorTherapyDetail", res, err, net);

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      doctorTherapyDetail: null,
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch doctor therapy detail",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    doctorTherapyDetail: res || null,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Doctor therapy detail fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetDoctorList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getDoctorList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await DoctorList.list({
    apiToken,
    params: params || {},
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      doctorList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch doctor list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    doctorList: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Doctor list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetDoctorTherapyItemDetail: Handler = async (
  controller,
  { doctor_id, pk, params },
) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getDoctorTherapyItemDetail";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await DoctorTherapyItemDetailView.retrieve({
    doctor_id,
    pk,
    params: params || {},
    apiToken,
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  console.log("item detail", res, err);

  if (err || !res) {
    controller.setState({
      doctorTherapyItemDetail: null,
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch doctor therapy item detail",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    doctorTherapyItemDetail: res,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Doctor therapy item detail fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetDoctorTherapyList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getDoctorTherapyList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await DoctorTherapyListView.list({
    apiToken,
    params: params || {},
  });

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      doctorTherapyList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch doctor therapy list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    doctorTherapyList: Array.isArray(res.items) ? res.items : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Doctor therapy list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetScheduling: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getScheduling";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err, net] = await Scheduling.get({
    command: "DSBProviderFilter",
    apiToken,
    params: params || {},
  });

  console.log("cheduling:", res, err, net);

  if (["Invalid token.", "Token ผิดพลาด"].includes(err?.detail) || net?.response?.status === 401) {
    return;
  }

  if (err || !res) {
    controller.setState({
      schedulingList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch scheduling list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    schedulingList: Array.isArray(res) ? res : [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Scheduling list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetAuditLogList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getAuditLogList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  let allItems: any[] = [];
  let nextUrl: string | null = null;

  try {
    const [res, err] = await AuditLogListView.list({
      apiToken,
      params: { ...params, model: "employee" },
    });

    if (err || !res) throw err || new Error("No response");

    allItems = res.items || [];
    nextUrl = res.next || null;

    while (nextUrl) {
      const url = new URL(nextUrl);
      const queryParams: any = {};
      url.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });

      const [pageRes, pageErr] = await AuditLogListView.list({
        apiToken,
        params: { ...queryParams, model: "employee" },
      });

      if (pageErr || !pageRes) break;

      allItems = allItems.concat(pageRes.items || []);
      nextUrl = pageRes.next || null;
    }

    controller.setState({
      auditLogList: allItems,
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
      successMessage: {
        ...state.successMessage,
        [actionKey]: "Audit log list fetched successfully",
      },
      errorMessage: { ...state.errorMessage, [actionKey]: null },
    });
  } catch (error) {
    controller.setState({
      auditLogList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch audit log list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
  }
};

const fetchAllPaymentPages = async (apiToken: string, params: any): Promise<[any[], any]> => {
  const api = params?.isPaymentRelation
    ? PaymentRelationListView.list
    : AppointmentPaymentRelationListView.list;

  const [res, err] = await api({
    apiToken,
    params,
  });

  if (err || !res) return [[], err];

  let allItems = res.items || [];
  let nextUrl = res.next || null;

  while (nextUrl) {
    const url = new URL(nextUrl);
    const queryParams: any = {};
    url.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    const [pageRes, pageErr] = await api({
      apiToken,
      params: queryParams,
    });

    if (pageErr || !pageRes) break;
    allItems = allItems.concat(pageRes.items || []);
    nextUrl = pageRes.next || null;
  }

  return [allItems, null];
};

export const HandleGetAppointmentPaymentRelationList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getPaymentList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [allItems, err] = await fetchAllPaymentPages(apiToken, params);

  if (err) {
    controller.setState({
      appointmentPaymentRelationList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch payment list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    appointmentPaymentRelationList: allItems,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Payment list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetUserDetail: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getUserDetail";

  const pk = params?.pk;
  console.log("🔍 Fetching user detail for pk:", pk);

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await UserDetailAPIView.retrieve({
    pk,
    apiToken,
  });

  if (err || !res) {
    controller.setState({
      userDetail: null,
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch user detail",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    userDetail: res,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "User detail fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandlePostAppointmentPaymentRelationAction: Handler = async (
  controller,
  { pk, status, reasonText, division, isPaymentRelation },
) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "postPaymentAction";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const data: any = { action: status };
  if ((status === "REJECT" || status === "REJECT_REQUEST_REFUND") && reasonText) {
    data.remark = reasonText;
  }

  const api = isPaymentRelation ? PaymentActionView.put : AppointmentPaymentRelationActionView.put;

  const [res, err] = await api({
    pk,
    data,
    apiToken,
    extra: { division },
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "ไม่สามารถบันทึกการตรวจสอบได้ กรุณาลองใหม่อีกครั้ง",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "บันทึกการตรวจสอบสำเร็จ",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });

  await HandleGetAppointmentPaymentRelationList(controller, { isPaymentRelation });
};

export const HandleFilterAppointmentPaymentRelationList: Handler = async (
  controller,
  filterParams,
) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "filterPaymentList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const params: Record<string, any> = {
    isPaymentRelation: filterParams?.isPaymentRelation,
  };

  if (filterParams?.patient) params.patient = filterParams.patient;
  if (filterParams?.statuses?.length) params.statuses = filterParams.statuses.join(",");
  if (filterParams?.due_date_start) params.due_date_start = filterParams.due_date_start;
  if (filterParams?.due_date_end) params.due_date_end = filterParams.due_date_end;
  if (filterParams?.patient_paid_date_start)
    params.patient_paid_date_start = filterParams.patient_paid_date_start;
  if (filterParams?.patient_paid_date_end)
    params.patient_paid_date_end = filterParams.patient_paid_date_end;
  if (filterParams?.check_payment_date_start)
    params.check_payment_date_start = filterParams.check_payment_date_start;
  if (filterParams?.check_payment_date_end)
    params.check_payment_date_end = filterParams.check_payment_date_end;
  if (filterParams?.request_refund_date_start)
    params.request_refund_date_start = filterParams.request_refund_date_start;
  if (filterParams?.request_refund_date_end)
    params.request_refund_date_end = filterParams.request_refund_date_end;
  if (filterParams?.patient_appointment_statuses?.length)
    params.patient_appointment_statuses = filterParams.patient_appointment_statuses.join(",");
  if (filterParams?.doctor) params.doctor = filterParams.doctor;
  if (filterParams?.patient_appointment_start_date)
    params.patient_appointment_start_date = filterParams.patient_appointment_start_date;
  if (filterParams?.patient_appointment_end_date)
    params.patient_appointment_end_date = filterParams.patient_appointment_end_date;

  const [allItems, err] = await fetchAllPaymentPages(apiToken, params);

  if (err) {
    controller.setState({
      appointmentPaymentRelationList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch filtered payment list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    appointmentPaymentRelationList: allItems,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Filtered payment list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetMeHealthPackageList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getMeHealthPackageList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await MeHealthPackageListView.list({
    apiToken,
    params,
  });

  if (err || !res) {
    controller.setState({
      meHealthPackageList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Failed to fetch health package list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  let allItems = res.items || [];
  let nextUrl = res.next || null;

  while (nextUrl) {
    const url = new URL(nextUrl);
    const queryParams: any = {};
    url.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    const [pageRes, pageErr] = await MeHealthPackageListView.list({
      apiToken,
      params: queryParams,
    });

    if (pageErr || !pageRes) break;
    allItems = allItems.concat(pageRes.items || []);
    nextUrl = pageRes.next || null;
  }

  controller.setState({
    meHealthPackageList: allItems,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Health package list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleCreateMeHealthPackage: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "createMeHealthPackage";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await MeHealthPackageListView.create({
    apiToken,
    data: params.data,
    extra: {
      division: state?.userDetail?.division_id || "180",
      permission: "MEH:me_health_package_list - CREATE",
    },
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to create health package",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  const updatedList = [res, ...(state.meHealthPackageList || [])];

  controller.setState({
    meHealthPackageList: updatedList,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Health package created successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });

  await HandleGetMeHealthPackageList(controller, {});
};

export const HandleUpdateMeHealthPackage: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "updateMeHealthPackage";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await MeHealthPackageDetailView.update({
    pk: params.pk,
    apiToken,
    data: params.data,
    extra: {
      division: state?.userDetail?.division_id || "180",
      permission: "MEH:me_health_package_detail - UPDATE",
    },
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to update health package",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  const updatedList = (state.meHealthPackageList || []).map((pkg: any) =>
    pkg.id === res.id ? res : pkg,
  );

  controller.setState({
    meHealthPackageList: updatedList,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Health package updated successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });

  await HandleGetMeHealthPackageList(controller, {});
};

export const HandleGetTermsAndConditionsList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getTermsAndConditionsList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await TermsAndConditionsList.list({
    apiToken,
    params,
  });

  if (err || !res) {
    controller.setState({
      termsAndConditionsList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to fetch terms and conditions list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  let allItems = res.items || [];
  let nextUrl = res.next || null;

  while (nextUrl) {
    const url = new URL(nextUrl);
    const queryParams: any = {};
    url.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    const [pageRes, pageErr] = await TermsAndConditionsList.list({
      apiToken,
      params: queryParams,
    });

    if (pageErr || !pageRes) break;
    allItems = allItems.concat(pageRes.items || []);
    nextUrl = pageRes.next || null;
  }

  controller.setState({
    termsAndConditionsList: allItems,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Terms and conditions list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleCreateTermsAndConditions: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "createTermsAndConditions";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await TermsAndConditionsList.create({
    apiToken,
    data: params.data,
    extra: {
      division: state?.userDetail?.division_id || "180",
      permission: "MEH:terms_and_conditions - CREATE",
    },
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to create terms and conditions",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  const updatedList = [res, ...(state.termsAndConditionsList || [])];

  controller.setState({
    termsAndConditionsList: updatedList,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Terms and conditions created successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
  await HandleGetTermsAndConditionsList(controller, {});
  await HandleGetLatestTermsAndConditions(controller, {});
};

export const HandleGetLatestTermsAndConditions: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getLatestTermsAndConditions";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await TermsAndConditionsLatestDetail.retrieve({
    apiToken,
    params: {
      category: "SERVICE",
    },
  });

  if (err) {
    if (err.response?.status === 404) {
      controller.setState({
        latestTermAndConditions: null,
        buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
        successMessage: {
          ...state.successMessage,
          [actionKey]: "No terms and conditions found",
        },
        errorMessage: { ...state.errorMessage, [actionKey]: null },
      });
      return;
    }

    controller.setState({
      latestTermAndConditions: null,
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to fetch latest terms and conditions",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    latestTermAndConditions: res || null,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Latest terms and conditions fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleUpdateTermsAndConditions: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "updateTermsAndConditions";

  const { id, content, isPublish } = params.data || {};
  const action = isPublish ? "PUBLISH" : "DRAFT";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  if (!id) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: "Missing terms and conditions ID for update",
      },
    });
    return;
  }

  const [res, err] = await TermsAndConditionsDetail.update({
    pk: id,
    apiToken,
    data: {
      category: "SERVICE",
      action,
      content,
    },
    extra: {
      division: state?.userDetail?.division_id || "180",
      permission: "MEH:terms_and_conditions_detail - UPDATE",
    },
  });

  if (err || !res) {
    controller.setState({
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to update terms and conditions",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    latestTermAndConditions: res,
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Terms and conditions updated successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });

  await HandleGetTermsAndConditionsList(controller, {});
  await HandleGetLatestTermsAndConditions(controller, {});
};

export const HandleGetTermsAndConditionsActionLogList: Handler = async (controller, params) => {
  const state = controller.getState();
  const apiToken = controller.apiToken;
  const actionKey = "getTermsAndConditionsActionLogList";

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "LOADING" },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
    successMessage: { ...state.successMessage, [actionKey]: null },
  });

  const [res, err] = await TermsAndConditionsActionLogList.list({
    apiToken,
    params: {
      category: "SERVICE",
      ...params,
    },
  });

  if (err || !res) {
    controller.setState({
      termsAndConditionsActionLogList: [],
      buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "ERROR" },
      errorMessage: {
        ...state.errorMessage,
        [actionKey]: err?.message || "Failed to fetch terms and conditions action log list",
      },
      successMessage: { ...state.successMessage, [actionKey]: null },
    });
    return;
  }

  controller.setState({
    termsAndConditionsActionLogList: res.items || [],
    buttonLoadCheck: { ...state.buttonLoadCheck, [actionKey]: "SUCCESS" },
    successMessage: {
      ...state.successMessage,
      [actionKey]: "Terms and conditions action log list fetched successfully",
    },
    errorMessage: { ...state.errorMessage, [actionKey]: null },
  });
};

export const HandleGetBonusCreditForNewOA: Handler = async (controller, params) => {
  const serviceCode = "BONUS_NEW_OA_CREDIT";
  const currentDate = moment().tz("Asia/Bangkok").format("YYYY-MM-DDTHH:mm:ssZ");

  const [resp, err] = await MeHealthServicePricingListView.list({
    apiToken: controller.apiToken,
    params: {
      service_code: serviceCode,
      specific_datetime: currentDate,
    },
    // extra: { division: controller.data.division || 0 },
  });

  if (err || !resp) return null;

  const firstItem = resp.items?.[0] || null;

  return firstItem;
};

export const HandleGetCreditWalletLatest: Handler = async (controller, params) => {
  const [resp, err] = await MeHealthCreditWalletLatestDetailView.retrieve({
    apiToken: controller.apiToken,
    extra: { division: controller.data?.division || 0 },
  });

  if (err || !resp) {
    console.warn("GetCreditWaller err: ", err);
    return;
  }

  controller.setState((prev) => ({
    BillingCreditWallet: resp,
  }));
};

// ======================= Phlebotomy Queue =======================
export const GetPhlebotomyQueue: Handler = async (controller) => {
  const [resp, err] = await LabOrderPhlebotomyQueueList.get({
    apiToken: controller.apiToken,
    extra: { division: controller.data.division },
  });

  if (err || !resp) return;

  controller.setState({
    phlebotomyQueue: {
      appointments: resp.appointments || [],
      walk_ins: resp.walk_ins || [],
    },
  });
};

export const SelectCustomerByPatientId: Handler = async (controller, params) => {
  const [resp] = await ProxyPatientHasDivisionAdminList.list({
    apiToken: controller.apiToken,
    params: { patient: params.patientId, limit: 1 },
    extra: { division: controller.data.division },
  });

  const customer = resp?.items?.[0];

  if (!customer?.id || !customer?.proxy_patient) return;

  controller.setState({
    meBillingActiveTab: 0,
    meBillingInitialMenu: params.initialMenu,
  });

  controller.handleEvent({
    message: "RunSequence",
    params: {
      sequence: "MeBilling",
      action: "GET_CUSTOMER_DETAIL",
      customerId: customer.id,
      proxyPatientId: customer.proxy_patient,
    },
  });
};

const speakQueue = async (vn: string) => {
  const PAUSE_MS = 80;

  const play = (file: string) =>
    new Promise<void>((resolve) => {
      const audio = new Audio(`/static/audio/queue/${file}.mp3`);
      audio.onended = () => resolve();
      audio.onerror = () => resolve();
      audio.play().catch(() => resolve());
    });

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  const playWithPause = async (file: string) => {
    await play(file);
    await sleep(PAUSE_MS);
  };

  await playWithPause("call");

  const parts = vn.split("/");
  for (let i = 0; i < parts.length; i++) {
    if (i > 0) await playWithPause("slash");
    for (const ch of parts[i]) {
      if (/[0-9]/.test(ch)) await playWithPause(ch);
    }
  }

  await play("kha");
};

export const CallPhlebotomyQueue: Handler = async (controller, params) => {
  if (params.vn) {
    speakQueue(params.vn);
  }

  const [resp, err] = await EncounterCallQueue.post({
    pk: params.encounterId,
    data: { queue_type: params.queueType },
    apiToken: controller.apiToken,
    extra: { division: controller.data.division },
  });

  if (err || !resp) {
    console.error("[Queue] CallQueue error:", err);
    return;
  }

  // Refresh queue
  GetPhlebotomyQueue(controller);

  if (params.patientId && !params.isCalled) {
    SelectCustomerByPatientId(controller, {
      patientId: params.patientId,
      initialMenu: "Specimen Collection",
    });
  }
};
